import React from 'react';
import {
    ServiceP,
    ServicesCard,
    ServicesContainer,
    ServicesH1,
    ServicesH2,
    ServicesWrapper
} from "./FormsElements";

const Forms = () => {
    return (
        <ServicesContainer id='forms'>
            <ServicesH1>Forms</ServicesH1>
            <ServicesWrapper>
                <a href={'/1099-forms'} style={{textDecoration: 'none', color: 'black'}}>
                    <ServicesCard>
                        <ServicesH2>1099 Forms</ServicesH2>
                        <ServiceP>File all 1099 forms online including 1099-MISC, 1099-NEC,and 1099-K and their
                            respective Correction Forms and State Filings.</ServiceP>
                    </ServicesCard>
                </a>
                <a href={'/w2-forms'} style={{textDecoration: 'none', color: 'black'}}>
                    <ServicesCard>
                        <ServicesH2>W2 Forms</ServicesH2>
                        <ServiceP>Save time and money! E-file your W2 tax forms for the lowest price with our
                            IRS-authorized platform. Simple, secure, and stress-free eFile. </ServiceP>
                    </ServicesCard>
                </a>
            </ServicesWrapper>
            <ServicesWrapper>
                <a href={'/payroll-forms'} style={{textDecoration: 'none', color: 'black'}}>
                    <ServicesCard>
                        <ServicesH2>94x Forms</ServicesH2>
                        <ServiceP>The IRS now support e-file Employer's QUARTERLY Federal Tax Return 941,Staying
                            compliant with payroll tax regulations is crucial for businesses. </ServiceP>
                    </ServicesCard>
                </a>
                <a href={'/aca-forms'} style={{textDecoration: 'none', color: 'black'}}>
                    <ServicesCard>
                        <ServicesH2>ACA Forms</ServicesH2>
                        <ServiceP>The Affordable Care Act (ACA) requires that certain employers provide you with a new
                            tax form called Form 1095-C Employer-Provided Health Insurance Offer and Coverage (or
                            alternatively, Form 1095-B Health Coverage)</ServiceP>
                        {/*<ServiceP><a href='https://support.taxfile.app/hc/en-us/articles/24184385988371-How-to-file-an-extension-of-time-for-a-tax-form-' target='_blank' rel="noreferrer">Here </a> is the instructions on how to file an extension. </ServiceP>*/}
                    </ServicesCard>
                </a>
            </ServicesWrapper>
            <ServicesWrapper>
                <ServicesCard>
                    <ServicesH2>Correction Forms</ServicesH2>
                    <ServiceP>Tax File App (TFA) support corrections for the last two years for all 1099, 1098, and
                        w2 forms, supporting last five years will be available soon. </ServiceP>
                    <ServiceP><a
                        href='https://support.taxfile.app/hc/en-us/articles/21319526225171-How-do-I-file-1099-Corrections-in-TaxFileApp-'
                        target='_blank' rel="noreferrer">Check out </a> the instructions on how to correct 1099 tax
                        forms.</ServiceP>
                </ServicesCard>
                <a href={'/tax-extensions'} style={{textDecoration: 'none', color: 'black'}}>
                <ServicesCard>
                    <ServicesH2>Extension Forms</ServicesH2>
                    <ServiceP>We generate Form 8809 for you for free. Tax File App will only provide the PDF for
                        printing, and we will NOT file the form with the IRS.</ServiceP>
                    <ServiceP><a
                        href='https://support.taxfile.app/hc/en-us/articles/24184385988371-How-to-file-an-extension-of-time-for-a-tax-form-'
                        target='_blank' rel="noreferrer">Here </a> is the instructions on how to file an extension.
                    </ServiceP>
                </ServicesCard>
                </a>
            </ServicesWrapper>
        </ServicesContainer>
    );
};

export default Forms;
